import { B as BxfTooltip$1, d as defineCustomElement$1 } from './p-cf5e3e4b.js';

const BxfTooltip = BxfTooltip$1;
const defineCustomElement = defineCustomElement$1;

export { BxfTooltip, defineCustomElement };
